import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { InputErrorAdditionalMessages } from '@qaroni-shared/types/input-error-additional-messages';

@Component({
  selector: 'qaroni-input-error-messages',
  templateUrl: './input-error-messages.component.html',
  styleUrls: ['./input-error-messages.component.scss'],
  standalone: false,
})
export class InputErrorMessagesComponent {
  readonly fc = input<AbstractControl | null>(null);
  readonly aditionalString = input<
    string | InputErrorAdditionalMessages | null
  >(null);

  public aditionalMessage(key: keyof InputErrorAdditionalMessages): string {
    const aditionalString = this.aditionalString();
    if (!aditionalString) {
      return '';
    }
    if (typeof aditionalString === 'string') {
      return aditionalString;
    }
    return aditionalString[key] ?? '';
  }
}
